import {Component, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {
  ColumnFilter,
  DataTableColumnData,
  DatatableComponent,
  DataTableConfig,
  DataTableDataSource,
  DataTableLazyLoadDataSource,
  DataTableLazyLoadRefresher, DataTableObservableCompletionListener, DataTableObservableErrorListener,
  TableAction
} from '@cas-hub/acabim-common-client';
import {AssetGroupService} from '../../../_services/asset-group-service';
import {AssetGroupResponse} from '../../../_models/asset-group.model';

@Component({
  selector: 'acabim-admin-asset-group',
  templateUrl: './asset-group.component.html',
  styleUrls: ['./asset-group.component.scss']
})
export class AssetGroupComponent implements OnInit {

  assetGroupsSub: Subscription | null = null;
  addAssetGroupModal = false;
  editAssetGroupModal = false;
  @ViewChild('dataTable') public dataTable!: DatatableComponent;
  public dataSources: DataTableDataSource<any>[] = [];

  constructor(
      private assetGroupService: AssetGroupService
  ) {}

  ngOnInit(): void {
    this.dataSources.push(
        new AssetGroupDataSource(
            (first, length, sortOrder, sortField, filters) =>
                this.assetGroupService.getAssetGroups(),
            (tableName: string, error: Error) => {
              console.log('[AssetGroupComponent] Error in retrieving data in table ' + tableName);
            },
            (tableName: string) => {
              console.log('[AssetGroupComponent] Completed retrieving data in table ' + tableName);
            }, (action: TableAction) => {
              if (action.id === 0) {
                console.log('[AssetGroupComponent] At action 0');
              } else if (action.id === 1) {
                console.log('[AssetGroupComponent] At action 1');
              }
            }
        )
    );

  }

  ngOnDestroy(): void {
    if (this.assetGroupsSub != null) {
      this.assetGroupsSub.unsubscribe();
    }
  }

  // Add
  onAddAssetGroup(): void {
    this.addAssetGroupModal = true;
  }

  setAddAssetGroupModal(value: boolean): void {
    this.addAssetGroupModal = value;
  }

  onAddCompletion(completed: string) {
    console.log(completed);
    this.addAssetGroupModal = false;
    if (completed === 'added') {
      this.setAddAssetGroupModal(false);
      this.dataTable?.requestImmediateDataRefresh();
    } else if (completed === 'cancelled') {
      this.setAddAssetGroupModal(false);
    }
  }

  // Edit
  setEditAssetGroupModal(value: boolean): void {
    this.editAssetGroupModal = value;
    this.dataSources[0].showDetails = value;
  }

  onEditCompletion(completed: string) {
    console.log(completed);
    this.editAssetGroupModal = false;
    if (completed === 'updated' || completed === 'deleted') {
      this.setEditAssetGroupModal(false);
      this.dataTable?.requestImmediateDataRefresh();
    } else if (completed === 'cancelled') {
      this.setEditAssetGroupModal(false);
    }
  }
}

export class AssetGroupDataSource extends DataTableLazyLoadDataSource<AssetGroupResponse> {

  readonly columnData: DataTableColumnData[] =
      [
        {displayName: 'Name', objectPropertyName: 'name', colWidth: '15rem'},
        {displayName: 'Description', objectPropertyName: 'description'}
      ];

  readonly config: DataTableConfig = {
    tableHeading: '',
    isSearchEnabled: false,
    searchPlaceHolder: 'Search asset groups',
    emptyMessage: '',
    globalFilterFields: [],
    hasCheckbox: false,
    hasDetailsButton: true,
    isLazyLoadingEnabled: false,
    isPaginationEnabled: false,
    hasFilters: false,
    isExportEnabled: false,
    hasActions: false
  };

  readonly columnFilters: ColumnFilter[] = [];

  readonly actions: TableAction[] = [{name: 'Archive', id: 0}, {name: 'Group', id: 1}];

  onDataExpanded(value: AssetGroupResponse): void {
  }

  constructor(readonly refresher: DataTableLazyLoadRefresher<AssetGroupResponse>,
              readonly observableErrorListener?: DataTableObservableErrorListener,
              readonly observableCompleteListener?: DataTableObservableCompletionListener,
              readonly actionListener?: (action: TableAction) => void) {
    super(refresher, observableErrorListener, observableCompleteListener);
  }

  onAction(action: TableAction): void {
    if (this.actionListener) {
      this.actionListener(action);
    }
  }
}

